export var QUERY_KEYS;
(function (QUERY_KEYS) {
    QUERY_KEYS["Statistics"] = "statistics";
    QUERY_KEYS["ConfigurationTypes"] = "configuration-types";
    QUERY_KEYS["StatisticByType"] = "statistic-by-type";
    QUERY_KEYS["CalcStatuses"] = "calcStatuses";
    QUERY_KEYS["Objects"] = "objects";
    QUERY_KEYS["DiagramStats"] = "diagramStats";
    QUERY_KEYS["HeatmapStats"] = "heatmapStats";
    QUERY_KEYS["Models"] = "models";
    QUERY_KEYS["Access"] = "access";
    QUERY_KEYS["Attributes"] = "attributes";
    QUERY_KEYS["UIData"] = "uiData";
    QUERY_KEYS["PvMvSv"] = "PvMvSv";
    QUERY_KEYS["ObjectsError"] = "objectsError";
    QUERY_KEYS["ValvePosition"] = "valvePosition";
})(QUERY_KEYS || (QUERY_KEYS = {}));
